// ==============================
// Imports
// ==============================

// Libraries
import React from 'react';
import { createRoot } from 'react-dom/client';

// Local components
import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import { ColorModeProvider } from './theme/ColorModeContext';
import { I18nProvider } from './i18n';

// ==============================
// Render
// ==============================
const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);

  root.render(
    <React.StrictMode>
      <I18nProvider>
        <ColorModeProvider>
          <App />
        </ColorModeProvider>
      </I18nProvider>
    </React.StrictMode>,
  );
}
